const LoaderSkeleton = () => (
  <div className="animate-pulse flex items-center justify-center w-full h-full bg-gray-200">
    <div className="h-[240px] w-full bg-gray-400 "></div>
  </div>
);

export default LoaderSkeleton;
